import { CircleStackIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { apiClient } from "../../services/api/apiClient";
import DuctStepModal from "./DuctStepModal";
import { ductSystemSteps } from "./stepConfigurations";
import toast from "react-hot-toast";

export default function CreateDuctSchedule({
  projectId,
  onSubmittalCreated,
  onOpenModal,
  onOpenSystemModal,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isStepModalOpen, setIsStepModalOpen] = useState(false);
  const [createdSubmittal, setCreatedSubmittal] = useState(null);

  const handleCreateDuctSchedule = async () => {
    if (!projectId) {
      setError("No project selected");
      return;
    }

    // Create the duct schedule first, then open DuctStepModal
    setLoading(true);
    setError(null);

    try {
      const createResponse = await apiClient.post(
        `/duct-schedule/${projectId}`
      );

      if (createResponse.success) {
        const newSubmittal = createResponse.data.submittal;
        setCreatedSubmittal(newSubmittal);

        // Open DuctStepModal with a small delay to ensure state update completes
        setTimeout(() => {
          setIsStepModalOpen(true);
        }, 100);
        toast.success("Duct schedule created successfully!");
      } else {
        const errorMsg =
          createResponse.message || "Failed to create duct schedule";
        setError(errorMsg);
        toast.error(errorMsg);
      }
    } catch (err) {
      const errorMsg = err.message || "Failed to create duct schedule";
      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleStepModalFinish = () => {
    // After DuctStepModal finishes, close it
    setIsStepModalOpen(false);

    // Notify parent immediately that submittal was created
    // This will cause the page to switch to DuctSchedule.js which has the template modal
    if (onSubmittalCreated && createdSubmittal) {
      onSubmittalCreated(createdSubmittal);
    }
  };

  return (
    <div>
      <div
        className={`border-2 border-dashed border-gray-300 rounded-lg px-12 py-8 min-w-[300px] flex flex-col items-center justify-center cursor-pointer hover:shadow-md transition ${
          loading ? "opacity-50 cursor-not-allowed" : ""
        }`}
        onClick={!loading ? handleCreateDuctSchedule : undefined}
      >
        <CircleStackIcon className="w-10 h-10 mb-2 text-gray-600" />
        <p className="text-md text-gray-600">
          {loading ? "Creating duct schedule..." : "Create a new duct schedule"}
        </p>
      </div>
      {error && (
        <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
        </div>
      )}
      <DuctStepModal
        isOpen={isStepModalOpen}
        onClose={() => setIsStepModalOpen(false)}
        steps={ductSystemSteps}
        onFinish={handleStepModalFinish}
      />
    </div>
  );
}
